import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function RewardFrame({
  amount,
  icon,
}: {
  amount: number
  icon: { alt: string; srcKey: string; height: number; width: number }
}): React.ReactElement {
  return (
    <div className="relative flex justify-center items-end bg-white w-20 h-14 p-1 text-purple rounded-large border-4 border-purple drop-shadow-white-sm">
      <ResponsiveImage
        alt={icon.alt}
        fit="contain"
        height={icon.height}
        imageClassName="absolute top-1 left-0 right-0 mx-auto"
        imageWidths={`${icon.width}`}
        srcKey={icon.srcKey}
        width={icon.width}
      />
      <p className="font-bold text-md z-10 text-shadow-outline-white leading-none">+{amount}</p>
    </div>
  )
}
